import { useTheme } from "@mui/material";

export default function BellIcon() {
  const theme = useTheme();

  return (
    <svg 
      width="16" 
      height="16" 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M8 12.6654C11.5826 12.6654 14 11.9342 14 10.1062C14 8.27827 13.3333 8.27827 12.8 7.91268C12.8 5.73142 12 1.33203 8 1.33203C4 1.33203 3.2 5.73142 3.2 7.91268C2.66667 8.27827 2 8.75997 2 10.1062C2 12.2998 4.41807 12.6654 8 12.6654Z" 
        fill={theme.palette.rgd.primary}
      />
      <path 
        d="M7.99967 14.6654C8.78181 14.6654 9.27031 14.3717 9.56853 14.0601C9.86837 13.7467 9.57953 13.332 9.14582 13.332H6.85352C6.41981 13.332 6.13097 13.7467 6.43081 14.0601C6.72902 14.3717 7.21753 14.6654 7.99967 14.6654Z" 
        fill={theme.palette.rgd.primary}
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M8.00013 0.199219C8.25786 0.199219 8.4668 0.408153 8.4668 0.665885V1.33255C8.4668 1.59028 8.25786 1.79922 8.00013 1.79922C7.7424 1.79922 7.53346 1.59028 7.53346 1.33255V0.665885C7.53346 0.408153 7.7424 0.199219 8.00013 0.199219Z" 
        fill={theme.palette.rgd.primary}
      />
    </svg>

  )
}